import { IApplicationState } from '../../../types/types';
import { getNumberKeys } from '../../../helper/getNumberKeys';

export const getTabIds = (
    state: IApplicationState
): number[] => {
    return getNumberKeys(state.model.tabs);
};
